module.exports = __webpack_public_path__ + "static/media/index.f8e06d0d.less";